import React from 'react';
import moment from 'moment';

const MAX_PEOPLE_PER_DATE = 4;

const formatDateString = (date) => moment(date).format('YYYY-MM-DD');

const isPastDate = (date) => {
  const now = moment();
  const mDate = moment(date);
  if (mDate.isSame(now, 'day')) {
    return now.hour() >= 10;
  }
  return mDate.isBefore(now, 'day');
};

const isBeyondThreeMonths = (date) => {
  const now = moment();
  const threeMonthsFromNow = moment().add(3, 'months');
  return moment(date).isAfter(threeMonthsFromNow, 'day');
};

const CalendarDay = ({ date, isSelected, onSelect, getBookingsCount, isDateAvailable }) => {
  if (!date) return <div className="p-1" />;

  const dateStr = formatDateString(date);
  const isPast = isPastDate(date);
  const isBeyond3Months = isBeyondThreeMonths(date);
  
  // FIX: isDateAvailable checks if date is NOT in disabled Ekadashi list
  const isNotEkadashi = isDateAvailable(date);
  
  // FIX: Get bookings count to check if slots are full
  const bookingsCount = getBookingsCount(dateStr);
  const slotsRemaining = MAX_PEOPLE_PER_DATE - bookingsCount;
  const isFull = bookingsCount >= MAX_PEOPLE_PER_DATE;

  // FIX: Date is disabled if it's past, beyond 3 months, Ekadashi, OR full
  const isDisabled = isPast || isBeyond3Months || !isNotEkadashi || isFull;

  const getClassName = () => {
    let className = 'p-2 text-center border rounded d-flex flex-column justify-content-center align-items-center small';

    if (isPast) {
      className += ' bg-light text-muted disabled';
    } else if (isBeyond3Months) {
      className += ' bg-light text-muted disabled';
    } else if (!isNotEkadashi) {
      // Ekadashi dates - show in grey/secondary color
      className += ' bg-secondary text-white disabled';
    } else if (isFull) {
      // Fully booked dates - show differently
      className += ' bg-danger bg-opacity-10 text-danger border-danger disabled';
    } else {
      // Available dates with slots
      className += ' bg-white border-secondary text-dark hoverable';
    }

    // Selected state only for non-disabled dates
    if (isSelected && !isDisabled) {
      className += ' bg-warning border-warning text-dark fw-bold';
    }

    return className;
  };

  const getStatusText = () => {
    if (isPast) {
      return <span className="d-none d-sm-inline text-muted">Past</span>;
    }
    if (isBeyond3Months) {
      return <span className="d-none d-sm-inline text-muted">Too far</span>;
    }
    if (!isNotEkadashi) {
      return <span className="d-none d-sm-inline text-danger fw-medium">Ekadashi</span>;
    }
    if (isFull) {
      return <span className="d-none d-sm-inline text-danger fw-medium">Full</span>;
    }
    if (bookingsCount > 0) {
      return (
        <span className="d-none d-sm-inline text-primary fw-medium">
          {slotsRemaining} left
        </span>
      );
    }
    return <span className="d-none d-sm-inline text-success fw-medium">Available</span>;
  };

  return (
    <div
      className={getClassName()}
      onClick={() => !isDisabled && onSelect(date)}
      style={{
        minHeight: '60px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease'
      }}
    >
      <div className="fw-semibold">{moment(date).date()}</div>
      <div className="mt-1 small">{getStatusText()}</div>
    </div>
  );
};

export default CalendarDay;